export default "__VITE_ASSET__DeXd_aJ___"